import { cn } from "src/lib/cn";
import { MultiOptionSelect, useSelectItem } from "../../../sudokit/components/SudoSelect/MultiOptionSelect";
import { useSudowriteStore } from "src/stores/sudowriteStore";
import { TENSES, TENSE_OPTIONS, isAutoTense } from "../../../../../src/shared/constants";
import Toggle from "src/components/Toggle";
import { Text } from "src/sudokit/components/Text";

const TenseRadioButtons = ({ value, onChange }) => {
  const tense = isAutoTense(value) ? TENSES.AUTO : value;
  useSelectItem(tense, true);

  return (
    <div>
      <div className="px-2 pb-2">
        {TENSE_OPTIONS.map((option) => (
          <div
            key={option.value}
            className={cn(
              "flex items-center gap-2 pb-3 pt-2 px-2.5 mt-2 mb-2 last:mb-0 text-white bg-app-document-background !border !border-solid duration-150 ease-in-out cursor-pointer rounded-lg",
              value === option.value
                ? "!border-app-primary-cta-high-contrast text-app-primary-cta-high-contrast cursor-default hover:cursor-default"
                : "!border-app-grey-2 text-app-grey-0 hover:text-app-grey-0 hover:!border-app-grey-1 hover:bg-app-grey-4 active:scale-[0.995] hover:scale-[1.005] cursor-pointer"
            )}
            onClick={() => onChange(value === option.value ? TENSES.NONE : option.value)}
          >
            {/* Set the value on the parent so the whole box is clickable */}
            <Toggle checked={value === option.value} />
            <div className="w-[90%] font-inter">
              <Text
                size="base"
                weight="medium"
                color={value === option.value ? "primary-cta" : "grey-0"}
                font="inter"
              >
                {option.label}
              </Text>
              <span className={`text-left font-inter ${value === option.value ? "text-app-primary-cta-high-contrast" : "text-[var(--grey-2)]"}`}>
                <Text
                  lineHeight="snug"
                  weight="medium"
                  color={value === option.value ? "primary-cta" : "grey-2"}
                  font="inter"
                  size="sm"
                >
                  {option.description}
                </Text>
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export const TenseSelectorButton = ({ tense, setTense, showLabel = true }) => {
  const features = useSudowriteStore((state) => state.getFeatureFlags)();
  const value = isAutoTense(tense?.value) ? TENSES.AUTO : tense?.value;

  const { hasAccessToPOVAndTenseBeta } = features || {};

  const handleManualTenseChange = (selectedOption) => {
    setTense({ value: selectedOption, userChanged: true });
  };

  const summaryFn = (selectedValues) => {
    // Find the tense value
    const tenseValue = selectedValues[0]; // Should only be one selected value

    if (tenseValue && isAutoTense(tenseValue)) {
      return "Choose tense";
    }

    // Find the display label for the selected tense
    const selectedOption = TENSE_OPTIONS.find((option) => option.value === tenseValue);
    return selectedOption?.label || "Select tense";
  };

  if (!hasAccessToPOVAndTenseBeta) {
    return null;
  }

  return (
    <div className="flex items-center gap-2">
      {showLabel && <p className="font-inter font-medium text-app-grey-0">Tense:</p>}
      <MultiOptionSelect
        placeholder="Select tense"
        variant="tertiary"
        summaryFn={summaryFn}
        className="!w-[440px]"
      >
        <TenseRadioButtons
          value={value || TENSES.PAST}
          onChange={handleManualTenseChange}
        />
      </MultiOptionSelect>
    </div>
  );
};
